
import { Component, Prop } from 'nuxt-property-decorator'
import { FeaturesBannerItem } from '~/components/sections/FeaturesBanner.vue'

import PromoThemeMixin from '~/mixins/promo-theme.mixin'

import Feature from '~/components/comparator/features/Feature.vue'
import ComparatorFeaturesBanner from '~/components/banners/ComparatorFeaturesBanner.vue'

@Component({
  components: {
    ComparatorFeaturesBanner,
    Feature,
  },
})
export default class ComparatorFeatures extends PromoThemeMixin {
  @Prop({ required: true, type: String })
  title!: string

  @Prop({ required: false, type: String, default: '' })
  subtitle!: string

  get featuresBannerItems (): FeaturesBannerItem[] {
    return [
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-time.svg'),
        title: this.$t('compare.banner.other.1.title') as string,
        description: this.$t('compare.banner.other.1.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-crown.svg'),
        title: this.$t('compare.banner.other.2.title') as string,
        description: this.$t('compare.banner.other.2.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-lock.svg'),
        title: this.$t('compare.banner.other.3.title') as string,
        description: this.$t('compare.banner.other.3.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-headphones.svg'),
        title: this.$t('compare.banner.other.4.title') as string,
        description: this.$t('compare.banner.other.4.description') as string,
      },
    ]
  }
}
